import { DateWithPrecision } from '@/lib/remote-data/date-with-precision'
import * as _ from 'lodash-es'

function customClone(value: unknown) {
  return _.cloneDeepWith(value, singleValue => {
    if (singleValue instanceof DateWithPrecision) {
      const clonedValue = new DateWithPrecision()
      clonedValue.setTime(singleValue.getTime())
      clonedValue.setPrecision(singleValue.getPrecision())
      return clonedValue
    }

    if (singleValue instanceof Date) {
      return new Date(singleValue)
    }
  })
}

export function useClonedObject<T extends Record<string, any>>(record: T) {
  const { cloned, sync } = useCloned(record, { manual: true, deep: true, clone: customClone })
  const data = toReactive(cloned) as T

  // Reset clone as soon as the record changes
  watch(
    () => record,
    () => {
      sync()
    },
    { deep: true },
  )

  return {
    data,
    commit() {
      const keys = Object.keys(record) as Array<keyof T>
      for (const key of keys) {
        record[key] = data[key]
      }
    },
    cancel() {
      sync()
    },
  }
}
